"use client";

import { c as _c } from "react/compiler-runtime";
import { createContext, useContext, ReactNode } from "react";
import { useFilterStore } from "./useFilterStore";
import type { AppFilterContextValue, PageFilterState } from "./types";
export type { FilterState, PageFilterState, PageFilterRegistration } from "./types";

// ── Context ────────────────────────────────────────────────────────────────

const AppFilterContext = createContext<AppFilterContextValue | undefined>(undefined);

// ── Provider ───────────────────────────────────────────────────────────────

export function AppFilterProvider(t0) {
  const $ = _c(3);
  const {
    children
  } = t0;
  const filterStore = useFilterStore();
  let t1;
  if ($[0] !== children || $[1] !== filterStore) {
    t1 = <AppFilterContext.Provider value={filterStore} data-sentry-element="AppFilterContext.Provider" data-sentry-component="AppFilterProvider" data-sentry-source-file="AppFilterProvider.tsx">{children}</AppFilterContext.Provider>;
    $[0] = children;
    $[1] = filterStore;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}

// ── Hooks ──────────────────────────────────────────────────────────────────

function useAppFilterContext() {
  const ctx = useContext(AppFilterContext);
  if (!ctx) {
    throw new Error("usePageFilters must be used within an AppFilterProvider");
  }
  return ctx;
}
const EMPTY_PAGE: PageFilterState = {};
export function usePageFilters(pageKey) {
  const $ = _c(24);
  const {
    store,
    registerPage,
    toggleValue,
    setOperator,
    setPageFilters,
    clearFilter,
    clearAllFilters
  } = useAppFilterContext();
  const page = store[pageKey];
  const filters = page ?? EMPTY_PAGE;
  const t0 = page !== undefined;
  let t1;
  if ($[0] !== pageKey || $[1] !== toggleValue) {
    t1 = (filterKey, value) => toggleValue(pageKey, filterKey, value);
    $[0] = pageKey;
    $[1] = toggleValue;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== pageKey || $[4] !== setOperator) {
    t2 = (filterKey_0, operator) => setOperator(pageKey, filterKey_0, operator);
    $[3] = pageKey;
    $[4] = setOperator;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== pageKey || $[7] !== setPageFilters) {
    t3 = next => setPageFilters(pageKey, next);
    $[6] = pageKey;
    $[7] = setPageFilters;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== clearFilter || $[10] !== pageKey) {
    t4 = filterKey_1 => clearFilter(pageKey, filterKey_1);
    $[9] = clearFilter;
    $[10] = pageKey;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== clearAllFilters || $[13] !== pageKey) {
    t5 = () => clearAllFilters(pageKey);
    $[12] = clearAllFilters;
    $[13] = pageKey;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== filters || $[16] !== registerPage || $[17] !== t0 || $[18] !== t1 || $[19] !== t2 || $[20] !== t3 || $[21] !== t4 || $[22] !== t5) {
    t6 = {
      filters,
      isRegistered: t0,
      registerPage,
      toggleValue: t1,
      setOperator: t2,
      setPageFilters: t3,
      clearFilter: t4,
      clearAllFilters: t5
    };
    $[15] = filters;
    $[16] = registerPage;
    $[17] = t0;
    $[18] = t1;
    $[19] = t2;
    $[20] = t3;
    $[21] = t4;
    $[22] = t5;
    $[23] = t6;
  } else {
    t6 = $[23];
  }
  return t6;
}